import { TreeViewItem } from '../tree-section/components/tree-view/tree-view.type'

export type EmitEvent =
  'addEnvironment' | 'addEquipment' | 'addSector' | 'archive' | 'edit' | 'linkEquipment' | 'unarchive' | 'viewEquipment' | 'viewEquipmentWarranties' | 'viewMaintenance'

export interface ToEventResult {
  type: string
  data: any
}

export interface DetailsSectionServiceDispatchParams {
  id?: string
  type: EmitEvent
  item: TreeViewItem
  reloadPage?: boolean
}


export enum DialogEquipmentTabsEnum {
  ATTACHMENTS = 'ATTACHMENTS',
  CUSTOM_FIELDS = 'CUSTOM_FIELDS',
  GENERAL = 'GENERAL',
  HISTORY = 'HISTORY',
  MAINTENANCES = 'MAINTENANCES',
  WARRANTIES = 'WARRANTIES'
}
